import { getSourceAttributionLabel } from '../../utils/resultSources';

export default function SourceAttribution({ res, className = '', fallback = '' }) {
  const { label, sources, isMultiple } = getSourceAttributionLabel(res);
  const display = label || fallback;
  if (!display) return null;

  const tooltip = isMultiple ? sources.join('\n') : undefined;

  const multiClass = isMultiple
    ? 'cursor-help rounded border border-cyan-500/35 bg-cyan-500/10 px-1.5 py-0.5'
    : '';

  return (
    <span
      className={`${multiClass} ${className}`.trim()}
      title={tooltip}
      {...(isMultiple ? { 'aria-label': `Sources: ${sources.join(', ')}` } : {})}
    >
      {display}
    </span>
  );
}
